export const onBodyScrollEndEvent = ({ params, onBodyScrollEnd }) => {
  if (onBodyScrollEnd) onBodyScrollEnd(params);
};